import Component from './view'

export { MAX_TOASTS, DEFAULT_TOAST_CLOSE, TOAST_TYPES } from './view'
export default Component
